"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var FilledPhone = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var setCanEditPhone = _a.setCanEditPhone;
    var data = (0, swr_hooks_1.useUser)().data;
    if (!((_e = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.contacts) === null || _e === void 0 ? void 0 : _e.phone))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, "+".concat((_j = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.profile) === null || _f === void 0 ? void 0 : _f.getOne) === null || _g === void 0 ? void 0 : _g.profile) === null || _h === void 0 ? void 0 : _h.contacts) === null || _j === void 0 ? void 0 : _j.phone)),
        react_1.default.createElement("div", { onClick: setCanEditPhone, className: styles_module_scss_1.default.editIcon })));
};
exports.default = FilledPhone;
